export const productDetail = {
    add_to_order:'ADD TO ORDER '
}